import { render, staticRenderFns } from "./UploadIdentity.vue?vue&type=template&id=1c243fc8&scoped=true"
import script from "./UploadIdentity.vue?vue&type=script&lang=js"
export * from "./UploadIdentity.vue?vue&type=script&lang=js"
import style0 from "./UploadIdentity.vue?vue&type=style&index=0&id=1c243fc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c243fc8",
  null
  
)

export default component.exports